/// <reference path="../../lib/app.d.ts" />

import {GiftCategory} from "../component/gift";
import {Options} from "../receiver/receiver";
import {TopupParams} from "../component/topup";
import {AuthParams} from "../chatserver/sx-server";

export interface InitialRoomData
{
	roomID : string;
	screenName : string;
	profilePic : string;
}

export interface AppParamsURL
{
	terms : string | Function;
	support : string;
	privacy : string | Function;
}

export interface MemberIncentiveParams
{
	timeout1 ?: number;
	timeout2 ?: number;
	success : boolean;
	canWatch : boolean;
	needToDisturb : boolean | "phase1" | "phase2"
}


export interface SecurionPayChatNotificationEventParams {
	success ?: boolean;
	type ?: "autopay" | "generic";
}

export interface SecurionPayChatEventHandler
{
	showNotification(message : string, params : SecurionPayChatNotificationEventParams) : void,
	promoUpdated(promo : any) : void;
	setCurrentPromo(promo : any) : void;
	updatePushPromo(data : any) : void;
}

export interface SecurionPayChatHandler
{
	register(eventHandler : SecurionPayChatEventHandler) : void;


	unRegister() : void;

	doQuickBuy(amount : number,
	           special : any,
	           onReady : (success : boolean, data : any) => void) : void;

	doPurchase(amount : number,
	           name : string,
	           email : string,
	           card : string,
	           expYear : string,
	           expMonth : string,
	           cvc : string,
	           store : boolean,
	           autoPay : boolean,
	           onReady : (success : boolean, data : any) => void) : void;

}

export interface UiParams
{
	stickerPath: string;
	templateFile  : string;
	defaultSize  ?: string;
	defaultRatio ?: string;
	emojiFile ?: string;
	emojiPath ?: string;

	registerURL : string;
	loginURL : string;

	cam2cam : CamToCamParams;
}

export interface CamToCamParams
{
	swf : string;
	minFlashVersion: string;
}

export interface Pom {
	start : number,
	end : number,
	perfid : number,
}

export interface AppParams
{
	showBoys: boolean;
	chatAPI: string;
	securionPayHandler : SecurionPayChatHandler;

	chatRoot : string;
	chatServer      : string;
	languageFile  : string;
	root          : JQuery;
	view          : UiParams;
	receiver      : Options;
	auth          : AuthParams;

	poms: Pom[]

	gift : {
		list : Array<GiftCategory>;
		root : string;
	};

	url : AppParamsURL

	userAuth : {

		captchaURL : string;

		register(user : string,
		         email : string,
		         passwd : string,
		         onReady : (res : string) => void) : void;

		login(user : string,
		      passwd : string,
		      captcha : string,
		      remember : boolean,
		      onReady : (res : string) => void) : void;

		reminder(email : string,
		         onReady: (res : string ) => void ) : void
	};

	topup : TopupParams;

	memberIncentive : {
		check : (room: string, callback: (result : MemberIncentiveParams) => void) => void;
		trigger : (room : string, level : string, screenName, onReady : () => void) => void;
		setWatched : (room : string) => void;
	},

	updateBrowserHistory?: boolean;

	chatIncludeType : string;
	chatForceWindowHeightFS : number;
}
